import { Navigate } from 'react-router-dom';

const isTokenValid = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1])); // Decode JWT payload
        return payload.exp * 1000 > Date.now(); // Check if token is expired
    } catch (e) {
        return false; // Invalid token format
    }
};

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('access_token');

    return token && isTokenValid(token) ? children : <Navigate to="/login" replace />;
};


export default ProtectedRoute;
